// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__KEdUu","note":"styles_note__E4K93"};